import RepositoryRanges from "@/repositories/v2/repository-ranges/RepositoryRanges";
import Requisite from "@models/requisite/Requisite";
import ServiceMainApi from "@/services/v2/service-main-api/ServiceMainApi";
import {plainToInstance} from "class-transformer";
import AgentsAmountRanges from "@models/errors/components/AgentsAmountRanges";
import ModelLightRanges from "@models/v2/ranges/ModelLightRanges";

export default class ServiceRanges {
	private static _instance: ServiceRanges | null = null;
	private readonly _repositoryRanges: RepositoryRanges;

	constructor() {
		this._repositoryRanges = new RepositoryRanges();
	}

	public static of() {
		if (ServiceRanges._instance === null) {
			ServiceRanges._instance = new ServiceRanges();
		}

		return ServiceRanges._instance;
	}

	public async fetchWithdrawalRanges(requisite: Requisite) {
		return await this._repositoryRanges.fetchWithdrawalRanges(requisite.id);
	}

	public async fetchPurchaseLightRanges() {
		return await this._repositoryRanges.fetchPurchaseLightRanges();
	}
}
